module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFAQMAAAC3obSmAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAtJREFUeJxjYIABAAAKAAF/gHReAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/images/black-dot-overlay.png
// module id = 2399
// module chunks = 0